/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_State_RunningInputs */

const vi_station_work_state_running = /** @type {(inputs: Station_Work_State_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang diễn ra`)
};

/**

* @param {Station_Work_State_RunningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_state_running = /** @type {((inputs?: Station_Work_State_RunningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_State_RunningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_state_running(inputs)
});